import { atom } from "recoil";

export const IdSelectDuAnState = atom({
  key: "IdSelectDuAnState",
  default: undefined,
});
